/* NicheCanvas | PDP sale-price layouts (v6, layout: invoice) | TH-57
   Shipped in the theme on 2026-10-13 from Intelligems test aa7f39fa, arm C "Invoice box (v8)"
   (William's decision), so turning Intelligems off cannot roll it back. The code is the arm's code;
   only these header notes, the kill note and the QA source marker changed.
   For the selected variant, shows the price the cart would charge for that unit: automatic
   discounts plus the discount codes the visitor's cart carries (read from /cart.js, the cart
   is the only source of truth). Applies nothing and never changes the visitor's cart.
   Price source: a throwaway 1-line Storefront API cart (tokenless, API 2026-10), created from a
   Web Worker because Shopify's patched window.fetch/XHR turn a cartCreate into a
   product_added_to_cart event.
   v8 rule (William, 2026-10-06): the PDP shows the item's own price as if BUY 2 GET 1 FREE did not
   exist. A per-item percentage discount (the sale) is painted whatever the cart holds; BUY 2 GET 1
   FREE only shows up in the cart, as a surprise (a 1-unit quote never triggers it). Other
   discounts (fixed amounts, codes that are not a per-item percentage) are painted only with an
   empty cart. When nothing applies, or when any check fails, the theme is left untouched.
   Layouts (same engine, same prices; only the presentation differs):
   - net:     net price first. Big final price with the list price struck beside it, then one
              line "<discount title> applied \u00b7 You save $X". Shown on mobile above Sezzle.
   - band:    discount already included. A drawer-style green band "<title> applied
              automatically / Already included in the price below", then struck list price,
              big final price and "You save $X".
   - receipt: selection receipt. A card with the selection, the regular price, the discount line
              and "Your price". On desktop the price block and Sezzle move under the options.
   Buy-box layouts: the price, Add to Cart and Sezzle sit together in one box under the options
   (desktop too, so the eye never goes back to the top), and "See it in your room" moves under it
   with an arrow instead of its TRY NOW button (mobile).
   - card:    mobile: green tag band "<title> applied", "Your selection", then
              final | regular (struck) | Save $X, the button, Sezzle centered. Desktop: the invoice box.
   - invoice: rows "Regular price", "<title> applied  -$X", "Your price", then the button,
              which says only "Add to Cart" (the total sits right above it).
   - strip:   no box: the green tag band and the final | regular | Save line above the button.
   - anchor:  the card with the regular price first (large, red) and the final price in green.
   Common to all layouts: sale prices in the size tiles, Sezzle and the Add to Cart button.
   Nothing is hardcoded: title, amounts and currency come from the cart.
   Kill: set ENABLED = false below, or remove the nc-pdp-invoice render from layout/theme.liquid.
   QA: window.__igFp (layout, results, errors, state(), refresh()). */
(function () {
  var LAYOUT = 'invoice';
  var ENABLED = true;
  if (!ENABLED || window.__igFp) return;

  var API = '/api/2026-10/graphql.json';
  var REQUEST_TIMEOUT_MS = 3500;
  var REVEAL_FAILSAFE_MS = 2500;
  var TTL_HIT_MS = 60 * 1000;      // a discounted quote: short, a sale can end mid-session
  var TTL_MISS_MS = 5 * 60 * 1000; // no discount: a stale miss can only show a higher price
  var RECHECK_MS = 90 * 1000;      // re-check a painted discount while the tab stays open
  var KEY = 'ncfp:v6:';
  var MAX_PARALLEL = 3;
  var MAX_FAILS = 3;               // consecutive failures before the session falls back to the theme

  var QA = window.__igFp = { v: 6, layout: LAYOUT, source: 'theme', results: {}, errors: [] };
  var html = document.documentElement;
  html.classList.add('ig5-L-' + LAYOUT);
  function ready() { html.classList.remove('ig-fp-wait'); html.classList.add('ig-fp-ready'); }

  function store(k, v) {
    try {
      if (v === undefined) return JSON.parse(sessionStorage.getItem(KEY + k) || 'null');
      sessionStorage.setItem(KEY + k, JSON.stringify(v));
    } catch (e) { return null; }
  }

  // The discount_code cookie is only a hint (it can outlive a code removed from the cart).
  function cookieCodes() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return [];
    try { return decodeURIComponent(m[1]).split(','); } catch (e) { return [m[1]]; }
  }

  var off = store('off') === true;
  if (off) return;

  // Hide PDP prices until the first quote only when a discount is likely (a code hint, a discount
  // already seen this session, or the session's first PDP). Otherwise the theme price shows at
  // once and is swapped only if a discount comes back.
  var expect = (cookieCodes().length > 0 || store('expect') === true || store('seen') !== true) &&
    location.pathname.indexOf('gift-card') === -1;
  if (expect) {
    html.classList.add('ig-fp-wait');
    setTimeout(ready, REVEAL_FAILSAFE_MS);
  }

  function fmt(cents, format) {
    format = format || '$' + '{' + '{amount}' + '}'; // no literal double braces in Intelligems payloads
    function delim(n, d, t, s) {
      var x = (n / 100).toFixed(d).split('.');
      return x[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (x[1] ? s + x[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/), v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      default: v = delim(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  // Shop money format without the padding spaces inside its <span class=money> (USD).
  function tight(format) { return String(format || '').replace(/>\s+/g, '>').replace(/\s+</g, '<'); }

  function normCodes(list) {
    var seen = {}, out = [];
    (list || []).forEach(function (c) {
      c = String(c || '').trim();
      if (c && !seen[c.toUpperCase()]) { seen[c.toUpperCase()] = 1; out.push(c); }
    });
    return out.sort();
  }

  // Visitor cart state: {codes, units}. Null until /cart.js answers; nothing is painted before.
  var cart = null;
  function customerId() {
    var st = window.__st, A = window.ShopifyAnalytics;
    return (st && st.cid) || (A && A.meta && A.meta.page && A.meta.page.customerId) || null;
  }
  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (c) {
        var list = c.discount_codes || [];
        // A logged-in customer's cart knows once-per-customer and segment rules that an anonymous
        // throwaway cart does not: keep only the codes that cart already accepts.
        if (customerId()) list = list.filter(function (d) { return d.applicable === true; });
        cart = { codes: normCodes(list.map(function (d) { return d.code; })), units: c.item_count || 0 };
        return cart;
      });
  }

  // Worker transport: no page fetch/XHR, so Shopify emits no add-to-cart pixel event.
  var worker, seq = 0, waiting = {};
  function getWorker() {
    if (worker !== undefined) return worker;
    try {
      var src = 'self.onmessage=function(e){var d=e.data;fetch(d.url,{method:"POST",credentials:"omit",' +
        'headers:{"Content-Type":"application/json",Accept:"application/json"},body:d.body})' +
        '.then(function(r){return r.json()}).then(function(j){self.postMessage({id:d.id,ok:true,json:j})},' +
        'function(x){self.postMessage({id:d.id,ok:false,error:String(x)})})}';
      worker = new Worker(URL.createObjectURL(new Blob([src], { type: 'text/javascript' })));
      worker.onmessage = function (e) {
        var cb = waiting[e.data.id];
        if (cb) { delete waiting[e.data.id]; cb(e.data); }
      };
      worker.onerror = function () {
        Object.keys(waiting).forEach(function (id) { var cb = waiting[id]; delete waiting[id]; cb({ ok: false, error: 'worker error' }); });
      };
    } catch (e) { worker = null; }
    return worker;
  }
  function gql(query, variables) {
    return new Promise(function (resolve, reject) {
      var w = getWorker();
      if (!w) { reject(new Error('no worker')); return; }
      var id = ++seq;
      var timer = setTimeout(function () { delete waiting[id]; reject(new Error('timeout')); }, REQUEST_TIMEOUT_MS);
      waiting[id] = function (res) {
        clearTimeout(timer);
        if (res.ok) resolve(res.json); else reject(new Error(res.error));
      };
      w.postMessage({ id: id, url: location.origin + API, body: JSON.stringify({ query: query, variables: variables }) });
    });
  }

  var ALLOC = 'discountAllocations{__typename discountedAmount{amount currencyCode}' +
    ' discountApplication{value{__typename}}' +
    ' ...on CartCodeDiscountAllocation{code} ...on CartAutomaticDiscountAllocation{title}' +
    ' ...on CartCustomDiscountAllocation{title}}';
  var MUTATION = 'mutation NcPdpPrice($lines:[CartLineInput!]!,$codes:[String!],$country:CountryCode)' +
    '@inContext(country:$country){cartCreate(input:{lines:$lines,discountCodes:$codes}){cart{' +
    'cost{totalAmount{amount currencyCode}} ' + ALLOC +
    ' lines(first:2){nodes{quantity merchandise{...on ProductVariant{id}}' +
    ' cost{amountPerQuantity{amount currencyCode} totalAmount{amount currencyCode}} ' + ALLOC + '}}}' +
    ' userErrors{code message}}}';

  function cents(m) { return Math.round(parseFloat(m.amount) * 100); }
  function sum(list) { return (list || []).reduce(function (a, x) { return a + cents(x.discountedAmount); }, 0); }
  function isPct(a) { return !!(a.discountApplication && a.discountApplication.value && a.discountApplication.value.__typename === 'PricingPercentageValue'); }
  function market() {
    var S = window.Shopify || {};
    return { country: S.country || 'US', currency: (S.currency && S.currency.active) || null };
  }

  var inflight = {}, fails = 0;
  function cacheKey(variantId, codes) {
    var mk = market();
    return [variantId, mk.country, mk.currency, codes.join(',')].join(':');
  }
  function cached(variant, codes) {
    var hit = store('q:' + cacheKey(variant.id, codes));
    if (!hit || hit.orig !== variant.price) return null;
    return Date.now() - hit.t < (hit.r ? TTL_HIT_MS : TTL_MISS_MS) ? hit : null;
  }

  // Exact standalone 1-unit price. Resolves {final, titles, codes, pctOnly} when a discount
  // applies (titles = automatic discounts, codes = discount codes), else null.
  function quote(variant, codes) {
    var key = cacheKey(variant.id, codes);
    var hit = cached(variant, codes);
    if (hit) return Promise.resolve(hit.r);
    if (inflight[key]) return inflight[key];
    var mk = market();
    var gid = 'gid://shopify/ProductVariant/' + variant.id;
    var p = gql(MUTATION, {
      lines: [{ merchandiseId: gid, quantity: 1 }],
      codes: codes,
      country: mk.country
    }).then(function (json) {
      var c = json && json.data && json.data.cartCreate && json.data.cartCreate.cart;
      var nodes = c && c.lines && c.lines.nodes;
      var line = nodes && nodes.length === 1 && nodes[0];
      if (!line || line.quantity !== 1 || !line.merchandise || line.merchandise.id !== gid) throw new Error('bad cart');
      var cur = line.cost.amountPerQuantity.currencyCode;
      var orig = cents(line.cost.amountPerQuantity);
      var final = cents(line.cost.totalAmount) - sum(c.discountAllocations);
      // Never show a price the cart would not charge.
      if (mk.currency && cur !== mk.currency) throw new Error('currency ' + cur);
      if (Math.abs(orig - variant.price) > 1) throw new Error('price drift ' + orig + ' vs ' + variant.price);
      if (c.cost && c.cost.totalAmount && final < cents(c.cost.totalAmount) - 1) throw new Error('final below cart total');
      var allocs = (line.discountAllocations || []).concat(c.discountAllocations || []);
      var titles = [], codesUsed = [];
      allocs.forEach(function (a) { if (a.code) codesUsed.push(a.code); else if (a.title) titles.push(a.title); });
      var r = final > 0 && final < orig
        ? { final: final, titles: normCodes(titles), codes: normCodes(codesUsed), pctOnly: allocs.length > 0 && allocs.every(isPct) }
        : null;
      store('q:' + key, { t: Date.now(), orig: variant.price, r: r });
      store('seen', true);
      fails = 0;
      return r;
    });
    inflight[key] = p;
    p.then(function () { delete inflight[key]; }, function (e) {
      delete inflight[key];
      QA.errors.push(String(e && e.message || e));
      if (++fails >= MAX_FAILS) { off = true; store('off', true); }
    });
    return p;
  }

  // Paint the 1-unit quote only when it is the marginal cost of adding this unit.
  function gate(r) {
    if (!r || !cart || off) return null;
    // v8: a per-item percentage (the sale) is shown whatever the cart holds, as if BUY 2 GET 1 FREE
    // did not exist (it only shows up in the cart). Other discounts: only with an empty cart.
    if (cart.units >= 1 && !r.pctOnly) return null;
    return r;
  }

  // Small queue so a size row never fires more than MAX_PARALLEL carts at once.
  var active = 0, queue = [];
  function next() { while (active < MAX_PARALLEL && queue.length) queue.shift()(); }
  function limited(fn) {
    return new Promise(function (resolve, reject) {
      queue.push(function () {
        active++;
        fn().then(resolve, reject).then(function () { active--; next(); });
      });
      next();
    });
  }

  // Customer-facing copy, built only from the cart's discount data.
  // "Fall Sale 20% Off applied" / "Code NC30 applied" (codes never combine with the sale here).
  function appliedText(r, suffix) {
    var parts = [];
    if (r.titles.length) parts.push(r.titles.join(' + ') + ' ' + suffix);
    if (r.codes.length) parts.push('Code ' + r.codes.join(', ') + ' applied');
    return parts.join(' \u00b7 ');
  }
  function discountLabel(r) {
    var parts = r.titles.slice();
    if (r.codes.length) parts.push('Code ' + r.codes.join(', '));
    return parts.join(' + ');
  }

  function node(tag, cls, text) {
    var e = document.createElement(tag);
    e.className = 'ig5 ' + cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function moneyNode(tag, cls, cents, format, prefix) {
    var e = node(tag, cls);
    e.innerHTML = fmt(cents, tight(format)); // shop money format only
    if (prefix) e.insertBefore(document.createTextNode(prefix), e.firstChild);
    return e;
  }
  function wasNode(cls, cents, format, noLabel) {
    var e = moneyNode('s', cls, cents, format);
    if (noLabel) return e;
    var sr = document.createElement('span');
    sr.className = 'ig-fp-sr';
    sr.textContent = 'Regular price ';
    e.insertBefore(sr, e.firstChild);
    return e;
  }

  function patch(f) {
    if (f.__igFp) return;
    f.__igFp = true;
    var s = f.settings || {};
    var origCur = f.updateCurrentVariant;
    var main = f.querySelector('#sezzle_target');
    var wrapper = main && main.parentElement;
    var content = wrapper && wrapper.parentElement;
    var btn = f.querySelector('.btn-add-to-cart');
    var atcPrice = btn && btn.querySelector('.product__price.no-currency');
    var painted = false, paintedAt = 0;
    var INJECTED = '.ig5';
    var BOX = ({ card: 1, invoice: 1, strip: 1, anchor: 1 })[LAYOUT] === 1;
    var sezBox = f.querySelector('.product__split-payments-box');
    var desk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: false };
    var box = null, boxWatch = null;
    // RoomViz inserts its banner right before the Add to Cart button whenever it loads. When it
    // loads after the box painted, it lands inside the box: move it out, just after the box.
    function evictForeign() {
      if (!box || !box.parentNode) return;
      box.querySelectorAll(':scope > .nc-roomviz-btn-wrapper').forEach(function (e) { box.parentNode.insertBefore(e, box.nextSibling); });
    }
    // Comment markers keep the theme's own spots for the button and Sezzle, so a clear puts them
    // back exactly. The box stays inside .product-content, so the button stays inside its form.
    function mark(el) {
      if (!el || !el.parentNode) return null;
      var m = document.createComment('ig6');
      el.parentNode.insertBefore(m, el);
      return { el: el, m: m };
    }
    var btnHome = BOX ? mark(btn) : null;
    var sezHome = BOX ? mark(sezBox) : null;
    // Layouts whose total sits right above the button: the button says only "Add to Cart".
    // The theme writes "Add to Cart&nbsp;&ndash;" as a text node before its price span.
    var PLAIN_ATC = ({ invoice: 1 })[LAYOUT] === 1;
    var atcLead = atcPrice && atcPrice.previousSibling && atcPrice.previousSibling.nodeType === 3 ? atcPrice.previousSibling : null;
    var atcLeadText = atcLead ? atcLead.nodeValue : null;
    function plainAtc(on) {
      if (!PLAIN_ATC || !atcLead || !atcPrice) return;
      atcLead.nodeValue = on ? atcLeadText.replace(/[\s\u00a0]*[\u2013\u2014-][\s\u00a0]*$/, '') : atcLeadText;
      atcPrice.classList.toggle('ig6-hide', on);
    }

    function selectionText() {
      var tile = f.querySelector('.product__form-option--selected[data-key="option2"] .text-bold');
      var size = tile ? tile.textContent.trim() : (f.form && f.form.option2) || '';
      return [f.form && f.form.option3, f.form && f.form.option1, size].filter(Boolean).join(' \u00b7 ');
    }

    function clearMain(v) {
      // The receipt layout moves #sezzle_target into its own row: put it back first.
      if (main && wrapper && main.parentNode !== wrapper) wrapper.insertBefore(main, wrapper.firstChild);
      if (main) main.classList.remove('ig6-final');
      if (box) {
        if (boxWatch) { boxWatch.disconnect(); boxWatch = null; }
        evictForeign();
        [btnHome, sezHome].forEach(function (h) { if (h && h.m.parentNode) h.m.parentNode.insertBefore(h.el, h.m); });
        box.remove();
        box = null;
        plainAtc(false);
      }
      f.querySelectorAll(INJECTED).forEach(function (e) { e.remove(); });
      if (wrapper) wrapper.classList.remove('ig-fp-on', 'ig5-w-net', 'ig5-w-band', 'ig5-w-receipt', 'ig6-w-empty');
      if (content) content.classList.remove('ig5-receipt-on', 'ig6-on');
      if (painted && v) {
        // Restore the theme's own price text (same formats as updateCurrentVariant).
        if (main) main.innerHTML = fmt(v.price, s.moneyFormatWithCurrency);
        if (atcPrice) atcPrice.innerHTML = fmt(v.price, s.moneyFormat);
      }
      painted = false;
    }

    function tagIcon() {
      var i = node('span', 'ig6-ico');
      i.setAttribute('aria-hidden', 'true');
      i.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.5"/></svg>';
      return i;
    }
    function row(label, amt, cls) {
      var e = node('div', cls);
      e.appendChild(typeof label === 'string' ? node('span', 'ig6-label', label) : label);
      e.appendChild(amt);
      return e;
    }
    // A price-line item that wraps to a new line drops its divider.
    function fixWrap() {
      if (!box) return;
      box.querySelectorAll('.ig6-pl').forEach(function (pl) {
        var kids = [].slice.call(pl.children);
        kids.forEach(function (c) { c.classList.remove('ig6-nl'); });
        for (var i = 1; i < kids.length; i++) {
          if (kids[i].getBoundingClientRect().top >= kids[i - 1].getBoundingClientRect().bottom - 2) kids[i].classList.add('ig6-nl');
        }
      });
    }
    function paintBox(v, r, fm) {
      var kind = LAYOUT === 'card' && desk.matches ? 'invoice' : LAYOUT;
      var saving = v.price - r.final;
      var cur = market().currency;
      box = document.createElement('div');
      box.className = 'ig6-box ig6-box--' + kind;
      main.innerHTML = fmt(r.final, tight(fm)) + (/^[A-Z]{3}$/.test(cur || '') ? '<span class="ig6-cur"> ' + cur + '</span>' : '');
      main.classList.add('ig6-final');
      if (kind === 'invoice') {
        box.appendChild(node('div', 'ig6-sel-b', selectionText()));
        box.appendChild(row('Regular price', wasNode('ig6-amt-was', v.price, fm, true), 'ig6-row'));
        var dl = node('span', 'ig6-label');
        dl.appendChild(tagIcon());
        dl.appendChild(document.createTextNode(appliedText(r, 'applied')));
        box.appendChild(row(dl, moneyNode('span', 'ig6-amt', saving, fm, '\u2212'), 'ig6-row ig6-row--disc'));
        box.appendChild(node('div', 'ig6-sep'));
        box.appendChild(row('Your price', main, 'ig6-row ig6-row--total'));
      } else {
        var band = node('div', 'ig6-band');
        band.appendChild(tagIcon());
        band.appendChild(node('span', 'ig6-band-t', appliedText(r, 'applied')));
        box.appendChild(band);
        if (kind !== 'strip') {
          box.appendChild(node('div', 'ig6-head', 'Your selection'));
          box.appendChild(node('div', 'ig6-sel', selectionText()));
        }
        var pl = node('div', 'ig6-pl');
        var was = wasNode('ig6-was', v.price, fm);
        if (kind === 'anchor') { pl.appendChild(was); pl.appendChild(main); } else { pl.appendChild(main); pl.appendChild(was); }
        pl.appendChild(moneyNode('span', 'ig6-save', saving, fm, 'Save '));
        box.appendChild(pl);
      }
      if (btnHome) { box.appendChild(btn); plainAtc(true); }
      if (sezHome) box.appendChild(sezBox);
      content.insertBefore(box, btnHome ? btnHome.m : null);
      wrapper.classList.add('ig6-w-empty');
      content.classList.add('ig6-on');
      if (typeof MutationObserver === 'function') {
        boxWatch = new MutationObserver(evictForeign);
        boxWatch.observe(box, { childList: true });
      }
      if (window.requestAnimationFrame) requestAnimationFrame(fixWrap);
    }

    function paintMain(v, r) {
      clearMain(v);
      if (!r || !v) return;
      var fm = s.moneyFormat;
      if (BOX && main && wrapper && content) {
        paintBox(v, r, fm);
      } else if (main && wrapper) {
        main.innerHTML = fmt(r.final, s.moneyFormatWithCurrency); // Sezzle reads one number here
        wrapper.classList.add('ig-fp-on', 'ig5-w-' + LAYOUT);
        var saveText = 'You save ';
        if (LAYOUT === 'band') {
          var band = node('div', 'ig5-band');
          band.appendChild(node('div', 'ig5-band-1', appliedText(r, 'applied automatically')));
          band.appendChild(node('div', 'ig5-band-2', 'Already included in the price below.'));
          wrapper.insertBefore(band, main);
          wrapper.insertBefore(wasNode('ig5-was ig5-was-line', v.price, fm), main);
          main.insertAdjacentElement('afterend', moneyNode('div', 'ig5-save', v.price - r.final, fm, saveText));
        } else if (LAYOUT === 'receipt') {
          var frag = document.createDocumentFragment();
          frag.appendChild(node('div', 'ig5-r-head', 'Your selection'));
          frag.appendChild(node('div', 'ig5-r-sel', selectionText()));
          var row1 = node('div', 'ig5-r-row');
          row1.appendChild(node('span', 'ig5-r-label', 'Regular price'));
          row1.appendChild(wasNode('ig5-r-was', v.price, fm, true));
          frag.appendChild(row1);
          var row2 = node('div', 'ig5-r-row ig5-r-disc');
          row2.appendChild(node('span', 'ig5-r-label', discountLabel(r)));
          row2.appendChild(moneyNode('span', 'ig5-r-amt', v.price - r.final, fm, '\u2212'));
          frag.appendChild(row2);
          frag.appendChild(node('div', 'ig5-r-sep'));
          var row3 = node('div', 'ig5-r-row ig5-r-total');
          row3.appendChild(node('span', 'ig5-r-label', 'Your price'));
          frag.appendChild(row3);
          wrapper.insertBefore(frag, main);
          row3.appendChild(main);
          if (content) content.classList.add('ig5-receipt-on');
        } else {
          var was = wasNode('ig5-was', v.price, fm);
          main.insertAdjacentElement('afterend', was);
          // One compact line: "<title> applied \u00b7 You save $X" (wraps on narrow screens)
          var line = node('div', 'ig5-line');
          line.appendChild(node('span', 'ig5-title', appliedText(r, 'applied') + ' \u00b7 '));
          line.appendChild(moneyNode('span', 'ig5-save', v.price - r.final, fm, saveText));
          was.insertAdjacentElement('afterend', line);
        }
      }
      if (atcPrice) atcPrice.innerHTML = fmt(r.final, fm);
      painted = true;
      paintedAt = Date.now();
    }

    function sizeSiblings() {
      if (!f.form || !f.form.option2 || !f.productOptions) return [];
      return f.product.variants.filter(function (x) {
        return x.option1 === f.form.option1 && x.option3 === f.form.option3 && x.price > 100;
      });
    }
    function tileFor(x) {
      var o = f.productOptions.find(function (e) { return e.dataset.key === 'option2' && e.dataset.value === x.option2; });
      return o && o.querySelector('.product__form-option-price');
    }
    function paintTile(x, r) {
      var pe = tileFor(x);
      if (!pe) return;
      pe.innerHTML = fmt(r ? r.final : x.price, s.moneyFormat);
      pe.classList.remove('ig-fp-pending');
    }

    // Reveal the main price, the button price and Sezzle as soon as the selected variant settles;
    // size tiles reveal one by one in paintTile().
    function revealMain() {
      f.querySelectorAll('.ig-fp-pending').forEach(function (n) {
        if (!n.classList.contains('product__form-option-price')) n.classList.remove('ig-fp-pending');
      });
      ready();
    }
    function unhide() {
      f.querySelectorAll('.ig-fp-pending').forEach(function (n) { n.classList.remove('ig-fp-pending'); });
    }

    var token = 0;
    var lastDiscounted = expect;
    function render() {
      var my = ++token;
      var v = f.getCurrentVariant && f.getCurrentVariant();
      if (!cart || off || !v || !(v.price > 100)) {
        paintMain(v, null);
        sizeSiblings().forEach(function (x) { paintTile(x, null); });
        unhide(); if (cart) ready();
        return Promise.resolve();
      }
      var codes = cart.codes;
      return quote(v, codes).then(function (r0) {
        if (my !== token) return;
        var r = gate(r0);
        if (r0) store('expect', !!r); // a discount the cart gates out stops reserving space
        QA.results[v.id] = r0;
        paintMain(v, r);
        lastDiscounted = !!r;
        var sibs = sizeSiblings();
        if (!r) { sibs.forEach(function (x) { paintTile(x, null); }); revealMain(); return; }
        paintTile(v, r);
        var waits = sibs.filter(function (x) { return x.id !== v.id; }).map(function (x) {
          var h = cached(x, codes);
          if (h) { paintTile(x, gate(h.r)); return null; }
          var pe = tileFor(x);
          if (pe) pe.classList.add('ig-fp-pending');
          return limited(function () { return my === token ? quote(x, codes) : Promise.resolve(null); })
            .then(function (rx) { if (my === token) paintTile(x, gate(rx)); }, function () { if (my === token) paintTile(x, null); });
        });
        revealMain();
        return Promise.all(waits);
      }, function () {
        if (my !== token) return;
        paintMain(v, null);
        sizeSiblings().forEach(function (x) { paintTile(x, null); });
        revealMain();
      }).then(function () { if (my === token) { unhide(); ready(); } });
    }

    // Re-read the cart; re-render when its codes or unit count changed, or when a painted
    // discount is older than its cache life (a sale can end while the tab stays open).
    function revalidate() {
      var before = cart ? cart.codes.join(',') + '|' + cart.units : '';
      return readCart().then(function (c) {
        var changed = c.codes.join(',') + '|' + c.units !== before;
        if (changed || (painted && Date.now() - paintedAt > TTL_HIT_MS)) return render();
      }, function () {});
    }

    // The theme rewrites prices on every option click: run the original, then re-render.
    f.updateCurrentVariant = function () {
      var out = origCur.apply(f, arguments);
      try {
        var v = f.getCurrentVariant && f.getCurrentVariant();
        var likely = cart && !off && (cart.codes.length > 0 || lastDiscounted);
        if (v && likely && !cached(v, cart.codes)) {
          // Keep the price block's box while the quote loads (no layout shift) and hide stale values.
          f.querySelectorAll('.product__price,.product__split-payments-box,.product__price-wrapper.ig5-w-receipt,' + INJECTED).forEach(function (n) { n.classList.add('ig-fp-pending'); });
          sizeSiblings().forEach(function (x) { var pe = tileFor(x); if (pe && !cached(x, cart.codes)) pe.classList.add('ig-fp-pending'); });
        } else {
          clearMain(null);
        }
        render();
        var t = token;
        setTimeout(function () { if (t === token) unhide(); }, REQUEST_TIMEOUT_MS + 500);
        revalidate();
      } catch (e) { unhide(); ready(); }
      return out;
    };

    var wrapTimer = null;
    window.addEventListener('resize', function () { clearTimeout(wrapTimer); wrapTimer = setTimeout(fixWrap, 150); });
    if (LAYOUT === 'card' && desk.addEventListener) desk.addEventListener('change', function () { if (painted) render(); });

    QA.refresh = function () { return readCart().then(function () { return render(); }); };
    QA.state = function () { var mk = market(); return { cart: cart, country: mk.country, currency: mk.currency, expect: expect, off: off, painted: painted, layout: LAYOUT }; };

    // First paint: a speculative no-code quote runs while /cart.js answers (most visitors carry no code).
    var v0 = f.getCurrentVariant && f.getCurrentVariant();
    if (v0 && v0.price > 100) quote(v0, []).catch(function () {});
    readCart().then(function () { return render(); }, function () { unhide(); ready(); });

    // Cart changes on this page (add to cart, drawer upsells), a code added later by a popup or a
    // link (cookie hint), a return to the tab and an open tab all re-check against the cart.
    document.addEventListener('nc:cart:add:success', function () { revalidate(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') revalidate(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) revalidate(); });
    var lastCookie = cookieCodes().join(',');
    setInterval(function () {
      var now = cookieCodes().join(',');
      if (now !== lastCookie) { lastCookie = now; revalidate(); }
    }, 2000);
    setInterval(function () { if (painted && document.visibilityState === 'visible') revalidate(); }, RECHECK_MS);

    // Codes added or removed in the UpCart drawer (code field, badge X) and quantity changes do not
    // touch the cookie: watch the drawer's shadow root and re-read the cart when its discount badges,
    // quantities or line count change. revalidate() re-renders only when the cart really changed.
    var drawerSig = null, drawerTimer = null;
    function drawerSignature(root) {
      var parts = [];
      root.querySelectorAll('.upcart-discount-code-text').forEach(function (e) { parts.push(e.textContent.trim()); });
      root.querySelectorAll('.upcart-product-quantity-input').forEach(function (e) { parts.push('q' + e.value); });
      return parts.join('|');
    }
    function watchDrawer() {
      var root = window.upcartDocumentOrShadowRoot;
      if (!root || typeof MutationObserver !== 'function') return false;
      drawerSig = drawerSignature(root);
      new MutationObserver(function () {
        clearTimeout(drawerTimer);
        drawerTimer = setTimeout(function () {
          var sig = drawerSignature(root);
          if (sig !== drawerSig) { drawerSig = sig; revalidate(); }
        }, 300);
      }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value'] });
      return true;
    }
    var drawerTries = 0;
    (function waitDrawer() { if (!watchDrawer() && ++drawerTries < 40) setTimeout(waitDrawer, 500); })();
  }

  var tries = 0;
  (function wait() {
    var f = document.querySelector('nc-product-form');
    if (f && f.product && f.form && typeof f.getCurrentVariant === 'function' &&
        typeof f.updateCurrentVariant === 'function' && f.querySelector('#sezzle_target')) {
      try { patch(f); } catch (e) { ready(); }
      return;
    }
    if (++tries < 200) setTimeout(wait, 50); else ready();
  })();
})();
